import store from '@/core/store';
import edit from './store/edit';

export const connect = (opts = {}) => {
  store.registerModule('terminals$edit', edit);
};
